
import { nanoid } from 'nanoid';

/**
 * Generates a unique, URL-friendly share ID for shared content
 * @returns A unique share ID string
 */
export function generateShareId(): string {
  // Generate a 10 character URL-friendly ID
  return nanoid(10);
}
